import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {antiNukeApi} from '../../../../http/Api';
import ChangeDetectedItem from '../../../template/ChangeDetectedItem/ChangeDetectedItem';
import StatusAntiNukeTamplate from '../../../template/status/statusBlock/StatusAntiNukeTamplate';
import WhiteListComponent from '../../../template/status/whiteList/WhiteListComponent';
import NotificationTamplateBlock from '../../../template/status/notifications/NotificationTamplateBlock';
import NotificationTamplateBlockPlug from '../../../template/status/notifications/NotificationTamplateBlockPlug';
import FlagCustomisationAntiNuke from '../../../template/flagCostomisationTamplate/FlagCustomisationAntiNuke';
import PopUpSubscribeTamplate from '../../../template/popUp/PopUpSubscribeTamplate';
import {useChanges} from '../../../../hooks/useChanges';
import {useAdvanceChanges} from '../../../../hooks/useAdvanceChanges';
import {getAntiNuke, getAntiNukeAdvanced} from '../../../../store/AntiNuke';

import './antiNukeComponent.scss';

const StatusAntiNuke = () => {
  const {handleSaveChanges, cancelChanges} = useChanges();
  const {handleSaveAdvanceChanges, cancelAdvanceChanges} = useAdvanceChanges();
  const [isPopUpSubscribe, setIsPopUpSubscribe] = useState(false);
  const {antiNukeGlobalState} = useSelector((state) => state.antiNuke);
  const {antiNukeAdvancedGlobalState} = useSelector((state) => state.antiNuke);
  const {changesDetected} = useSelector((state) => state.changeDetected);
  const {changesAdvanceDetected} = useSelector((state) => state.changeAdvanceDetected);
  const [isSubscribe, setIsSubscribe] = useState(antiNukeGlobalState?.data?.premium);

  return (
    <div className="setting_component_wrap">
      <div className="overview_component_content_head">
        <h4>Anti-Nuke</h4>
        <p>
          Prevent server destruction and malicious activity by monitoring and flagging suspicious
          user behaviour
        </p>
      </div>
      <div className="status_varification_content_wrap" style={{width: '100%'}}>
        <StatusAntiNukeTamplate data={antiNukeGlobalState} />
        <WhiteListComponent data={antiNukeGlobalState} />
        {!isSubscribe ? (
          <NotificationTamplateBlockPlug setIsPopUpSubscribe={setIsPopUpSubscribe} />
        ) : (
          <NotificationTamplateBlock data={antiNukeGlobalState?.data} />
        )}
        {isPopUpSubscribe && (
          <PopUpSubscribeTamplate
            setIsSubscribe={setIsSubscribe}
            setIsPopUpSubscribe={setIsPopUpSubscribe}
          />
        )}
        {changesDetected && (
          <ChangeDetectedItem
            cancel={cancelChanges}
            onSave={() => handleSaveChanges(antiNukeApi.updateAntiNuke, getAntiNuke)}
          />
        )}
      </div>
      <FlagCustomisationAntiNuke
        title={'Advance Settings'}
        text={'In-depth customisation with flexible flag system'}
        data={antiNukeAdvancedGlobalState?.data}
      />
      {changesAdvanceDetected && (
        <ChangeDetectedItem
          cancel={cancelAdvanceChanges}
          onSave={() =>
            handleSaveAdvanceChanges(antiNukeApi.updateAntiNukeAdvanced, getAntiNukeAdvanced)
          }
        />
      )}
    </div>
  );
};

export default StatusAntiNuke;
